module.exports = __webpack_public_path__ + "img/ad.8c821c9a.svg";